import {
  CHANGE_PAID_WAITING_COUNT,
  FETCH_GUEST_REVIEW_DETAIL,
  FETCH_HOSTS_REVIEWS,
  FETCH_OVERALL_STATISTICS,
  FETCH_PENDED_RESERVES,
  REMOVE_RESERVE_ITEM,
  FETCH_UNANSERWED_REVIEWS,
  FETCH_DELIVERY_KEYS,
  FETCH_HOST_REVIEW,
  FETCH_RESERVATION_INFO,
  FETCH_MY_HOUSES,
  FETCH_HOST_CALENDAR_DATA,
  FETCH_RESERVATIONS,
  CHANGE_RESERVATIONS_STATUS,
  FETCH_HOUSE_INFORMATION,
  FETCH_HOUSE_REVIEWS,
  FETCH_HOST_HOUSES_STATISTICS,
  FETCH_HOST_CHART_STATISTICS,
  FETCH_HOST_MESSAGES,
  FETCH_HOUSES,
  FETCH_USER_INFORMATION,
  CHANGE_HOST_PASSWORD,
  FETCH_TRANSACTIONS,
  FETCH_TRANSACTIONS_DETAILS,
  GET_SETTLEMENT,
  FETCH_HOUSE_PRICE_SUGGESTION,
  UPDATE_SETTLEMENT,
  FETCH_HOUSE_PRICING_LIST,
  SET_HOUSES,
  SET_PRICING,
  SET_STEP,
} from '../actions/types'
import { AnyAction } from 'redux'

export interface HostCalendarState {
  data: any
  loading: boolean
}

export const hostCalendarReducer = (
  state: HostCalendarState = {
    data: {},
    loading: false,
  },
  action: AnyAction,
) => {
  const data = {
    ...state.data,
  }

  switch (action.type) {
    case FETCH_HOST_CALENDAR_DATA:
      if (action.id && action.id) {
        data[action.id] = action.data
      }

      return {
        loading: action.loading,
        data,
      }

    default:
      return state
  }
}

export interface HostsPanelType {
  data: any
  loading: boolean
  page: number
}
export const hostsReducer = (
  state: HostsPanelType = {
    data: null,
    loading: false,
    page: 1,
  },
  action,
) => {
  switch (action.type) {
    case FETCH_HOSTS_REVIEWS:
      return {
        ...state,
        data: {
          ...state.data,
          reviews: action.data,
        },
        loading: action.loading,
      }
    case FETCH_UNANSERWED_REVIEWS:
      return {
        ...state,
        data: {
          ...state.data,
          unanswered_reviews: {
            data: action.data,
            loading: action.loading,
          },
        },
      }
    case FETCH_DELIVERY_KEYS:
      return {
        ...state,
        data: {
          ...state.data,
          delivery_keys: {
            data: action.data,
            loading: action.loading,
          },
        },
      }
    case FETCH_OVERALL_STATISTICS:
      return {
        ...state,
        data: {
          ...state.data,
          overall_statistics: {
            data: action.data,
            loading: action.loading,
          },
        },
      }
    case FETCH_PENDED_RESERVES:
      return {
        ...state,
        data: {
          ...state.data,
          pended_reserves: { data: action.data, loading: action.loading },
        },
      }
    case REMOVE_RESERVE_ITEM:
      return {
        ...state,
        data: {
          ...state.data,
          pended_reserves: {
            ...state.data.pended_reserves,
            data: {
              ...state.data.pended_reserves.data,
              records: state.data.pended_reserves.data.records?.filter(
                item => item.reserve_id !== action.payload,
              ),
            },
          },
        },
        loading: action.loading,
      }
    case CHANGE_PAID_WAITING_COUNT:
      return {
        ...state,
        data: {
          ...state.data,
          overall_statistics: {
            ...state.data.overall_statistics,
            data: {
              ...state.data.overall_statistics.data,
              wait_for_payment_reservations:
                state.data.overall_statistics.data
                  .wait_for_payment_reservations + action.payload,
            },
          },
        },
        loading: action.loading,
      }
    case FETCH_GUEST_REVIEW_DETAIL:
      return {
        ...state,
        data: {
          ...state.data,
          guest_review: action.data,
        },
        loading: action.loading,
      }
    case FETCH_HOST_REVIEW:
      return {
        ...state,
        data: {
          ...state.data,
          reviews: action.data,
        },
        loading: action.loading,
      }
    case FETCH_RESERVATION_INFO:
      return {
        ...state,
        data: {
          ...state.data,
          reservationInfo: action.data,
        },
        loading: action.loading,
      }
    case FETCH_MY_HOUSES:
      return {
        ...state,
        data: {
          ...state.data,
          myHouses: {
            ...state.data?.myHouses,
            [action.meta.type]: action.data,
          },
          loading: action.loading,
        },
      }
    case FETCH_HOST_HOUSES_STATISTICS:
      return {
        ...state,
        data: {
          ...state.data,
          houses_statistics: {
            ...state.data?.houses_statistics,
            data: action.data,
            houses_loading: action.loading,
          },
        },
        loading: action.loading,
      }
    case FETCH_HOST_CHART_STATISTICS:
      return {
        ...state,
        data: {
          ...state.data,
          chart_statistics: {
            ...state.data?.chart_statistics,
            data: action.data,
            chart_loading: action.loading,
          },
        },
        loading: action.loading,
      }
    case FETCH_RESERVATIONS:
      return {
        ...state,
        data: {
          ...state.data,
          reservations: {
            data: action.data,
            loading: action.loading,
          },
        },
      }
    case CHANGE_RESERVATIONS_STATUS:
      return {
        ...state,
        data: {
          ...state.data,
          reservations: {
            loading: false,
            data: {
              ...state.data.reservations.data,
              records: [...action.data],
            },
          },
        },
      }
    case FETCH_HOUSE_INFORMATION:
      return {
        ...state,
        data: {
          ...state.data,
          houseInfomation: action.data,
        },
        loading: action.loading,
      }
    case FETCH_HOUSE_REVIEWS:
      return {
        ...state,
        data: {
          ...state.data,
          houseReviews: {
            data: action.data,
            loading: action.loading,
          },
        },
      }
    case FETCH_HOUSES:
      return {
        ...state,
        data: {
          ...state.data,
          housesList: action.data,
          loading: action.loading,
        },
      }
    case FETCH_HOST_MESSAGES:
      return {
        ...state,
        data: {
          ...state.data,
          messages: action.data,
        },
        loading: action.loading,
      }
    case FETCH_USER_INFORMATION:
      return {
        data: {
          ...state.data,
          userInformation: action.data,
        },
        loading: action.loading,
      }
    case CHANGE_HOST_PASSWORD:
      return {
        data: {
          ...state.data,
          passwordInformation: action.data,
        },
        loading: action.loading,
      }
    case FETCH_TRANSACTIONS:
      return {
        ...state,
        data: {
          ...state.data,
          transactions: {
            data: action.data,
            loading: action.loading,
          },
        },
      }
    case FETCH_TRANSACTIONS_DETAILS:
      return {
        ...state,
        data: {
          ...state.data,
          transactionsDetails: {
            data: action.data,
            loading: action.loading,
          },
        },
      }
    case GET_SETTLEMENT:
      return {
        ...state,
        data: {
          ...state.data,
          settlement: {
            data: action.data,
            loading: action.loading,
          },
        },
      }
    case UPDATE_SETTLEMENT:
      return {
        ...state,
        data: {
          ...state.data,
          settlement: {
            ...state.data.settlement,
            data: {
              ...state.data.settlement.data,
              current_settlement_type: action.data,
            },
          },
        },
      }
    case FETCH_HOUSE_PRICE_SUGGESTION:
      return {
        ...state,
        data: {
          ...state.data,
          price_suggestion: {
            data: action.data,
            loading: action.loading,
          },
        },
      }
    case FETCH_HOUSE_PRICING_LIST:
      return {
        ...state,
        data: {
          ...state.data,
          housePricingList: action.data,
        },
        loading: action.loading,
      }
    case SET_HOUSES:
      return {
        ...state,
        data: { ...state.data, selectedHouseIds: action.data },
      }
    case SET_PRICING:
      return {
        ...state,
        data: {
          ...state.data,
          housePrices: action.data,
        },
      }
    case SET_STEP:
      return { ...state, currentStep: action.data }

    default:
      return state
  }
}
